<template>
  <div>
    <template v-for="menu in content">
      <el-submenu
        :key="menu.key"
        v-if="menu.children && menu.children.length > 0"
        :index="menu.key"
        :disabled="menu.isLock"
        :class="menu.isLock ? 'menu-lock' : ''"
      >
        <template slot="title">
          <span>{{ menu.name }}</span>
        </template>
        <subItem :content="menu.children" @getSubItem="onSubItemClick"></subItem>
      </el-submenu>
      <el-menu-item
        :key="menu.key"
        v-else
        :index="menu.key"
        :disabled="menu.isLock"
        :class="menu.isLock ? 'menu-lock' : ''"
        @click="onSubItemClick(menu)"
      >{{ menu.name }}</el-menu-item>
    </template>
  </div>
</template>

<script>
export default {
  name: "subItem",
  props: {
    content: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    onSubItemClick(item) {
      this.$emit("getSubItem", item);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-submenu.menu-lock.is-disabled{
  position: relative;

  .el-submenu__title{
    padding-right: 55px;
    opacity: 1;
  }

  &:after{
    content: '';
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    right: 40px;
    background: url("~@/assets/images/common/lock.png") center center no-repeat;
    background-size: contain;
    cursor: not-allowed;
  }
}
/deep/.el-menu-item.menu-lock.is-disabled{
  position: relative;

  &:after{
    content: '';
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    right: 20px;
    background: url("~@/assets/images/common/lock.png") center center no-repeat;
    background-size: contain;
    cursor: not-allowed;
  }
}
</style>